import { SyntheticEvent } from "react";

import ProductTileButtonComponent from "@/components/Product/ProductTile/components/button/productTileButton.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type MoreInfoProductTileButtonProps = {
    onClick: (e: SyntheticEvent<HTMLButtonElement>) => void;
    className?: string;
};

const MoreInfoProductTileButton = ({
    onClick,
    className
}: MoreInfoProductTileButtonProps) => {
    const { t } = useGranite();

    return (
        <ProductTileButtonComponent
            onClick={onClick}
            showOutline={false}
            className={className}
        >
            {t("productTile.button.moreInfo")}
        </ProductTileButtonComponent>
    );
};

export default MoreInfoProductTileButton;
